import { RepeatIcon } from '@chakra-ui/icons';
import {
  Button,
  Flex,
  Heading,
  Stack,
} from '@chakra-ui/react';
import React from 'react';
import { useFormState, useForm } from 'web-react-ui/src/reactFinalForm';
import FieldLabel from 'web-react-ui/src/reactFinalForm/fields/FieldLabel';
import TextArea from 'web-react-ui/src/reactFinalForm/fields/TextArea';
import {
  compose,
  min,
  replaceMessage,
  required,
} from 'web-react-ui/src/reactFinalForm/validators';

const CaptionSection = () => {
  const form = useForm();
  const formState = useFormState();
  const resetMessage = () => {
    form.change('output.message', formState.initialValues.output.message);
  };

  return (
    <Stack w="100%">
      <Flex w="100%" justifyContent="space-between">
        <Heading fontSize="1.5em" pb="1em">Caption</Heading>
        <Button onClick={resetMessage} size="sm" variant="outline">
          Revert Caption
        </Button>
      </Flex>
      <TextArea
        chakra
        wrapLabel
        name="output.message"
        placeholder="Enter a short post caption here"
        h="10lh"
        size="lg"
        validate={replaceMessage(
          compose(required, min(10)),
          () => 'Post caption cannot remain blank. Please provide at least 10 characters.',
        )}
      />
    </Stack>
  );
};

export default CaptionSection;
;
